import { SISTEMA } from '../../copy/index.js';
import { ES_ENTORNO_DE_DEMOSTRACION } from '../../lib/entorno.js';

/**
 * El aviso de que esto es una demostración (DEMO-1): una franja arriba de todo,
 * para que nadie confunda la demo con un sistema con pacientes reales.
 *
 * **Sólo en las pantallas que se ven sin sesión** (decisión de Mariano del
 * 06/10/2026): `/entrar` del equipo en sus tres pasos, la puerta del paciente
 * (sin enlace, el código, el código que no sirve, el enlace vencido) y la
 * sesión vencida. Adentro de la app, para cualquier rol, no aparece: ocupaba
 * una franja en cada pantalla de trabajo y avisaba lo que quien ya entró sabe.
 * Lo montan esas pantallas, no `App.tsx`. Se descartó que se cerrara solo a
 * los pocos segundos: un aviso que se va solo es fácil de no ver, y WCAG 2.2.1
 * pide que la persona controle los tiempos.
 *
 * Va en el flujo de la página y no fija: no tapa el encabezado de ninguna
 * pantalla, y a 360 px el texto se parte en dos líneas sin cortar nada. No se
 * cierra: mientras el entorno sea de demostración, lo dice.
 *
 * Lo enciende el build, no el código (`lib/entorno.ts`). El par de color es el
 * de la píldora naranja, que pasa AA como texto chico en negrita.
 */
export function AvisoDeDemostracion({
  encendido = ES_ENTORNO_DE_DEMOSTRACION,
}: {
  encendido?: boolean;
}) {
  if (!encendido) return null;

  return (
    <aside
      aria-label={SISTEMA.entornoDeDemostracion.rotulo}
      className="bg-warning-soft px-4 py-2 text-center text-sm font-bold text-warning-strong"
    >
      {SISTEMA.entornoDeDemostracion.aviso}
    </aside>
  );
}
